export default{
    
    data() {
        return{
            Productions:[],
            recordtotal:0,
            pageSize:10,
            pageIndex:1,
            editFormVisible:false,
            editForm:[],
            formLabelWidth: '90px',
            currentRowIndex:-1,
            bIsNew:false,
            listLoading:false,
            sName:'',
            sNameOrder:'',
            sCode:'',
            sCodeOrder:'',
        }
    },
    mounted () {
        var me = this;
        this.LoadData();
    },
    methods: {
        LoadData(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = 'Production/getlist';
            this.$axios.get(getMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,
                        'Name':me.sName,
                        'NameOrder':me.sNameOrder,
                        'Code':me.sCode,
                        'CodeOrder':me.sCodeOrder,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                    }
                })
            .then((response) => {
                if (response.data !='undefined' && response.data != null) {
                        me.Productions = response.data.DataSource;
                        me.recordtotal = response.data.TotalRecords;
                }
            })
            .catch(function (error) {
                console.log(error)
            });

            this.listLoading = false;
        },
        handleCurrentChange(val)
        {
            this.pageIndex = val;
            this.LoadData()
        },
        handleAdd(){
            this.bIsNew = true;
            this.currentRowIndex = -1;
            this.editFormVisible = true;
            this.editForm = Object.assign({}, {
                    'Id': 0,
                    'Name': '',
                    'Code': '',
                    'Weight':0.00,
                    'Cube': 0.000,
                    'Status': true                    
            }); //这句是关键！！！
        },
        handleRefresh()
        {
            this.listLoading = true;
            this.LoadData();
        },
        changeTableSort(column) {
            
             if (column.prop === 'Name') {
                if (column.order === 'descending') {
                    this.sNameOrder = "Desc";
                } else if (column.order === 'ascending') {
                   this.sNameOrder = "Asc";
                }
                this.sCodeOrder = "";
              } 
              else if (column.prop === 'Code') {
                if (column.order === 'descending') {
                    this.sCodeOrder = "Desc";
                } else if (column.order === 'ascending') {
                    this.sCodeOrder = "Asc";
                }
                this.sNameOrder = "";
              } 

              this.LoadData();
        },
        handleEdit(index, row) {
            this.bIsNew = false;
            this.currentRowIndex = index;
            this.editFormVisible = true;
            
            this.editForm = Object.assign({}, row); //这句是关键！！！
          },
        //点击关闭dialog
        handleClose(done) {
            /*done();
            location.reload();*/
            this.editFormVisible = false;
        },  
        //点击取消
        handleCancel() {
            this.editFormVisible = false;
        },
        //点击更新
        handleUpdate() { 
            this.editFormVisible = false;

            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            //Save Production
            var getMethod = 'Production/save';

            this.$axios.post(getMethod,
                {
                    'CurrentTokenId': user.TokenId,
                    'CurrentUser': user.LoginName,                 
                    'Id': me.editForm.Id,
                    'Name': me.editForm.Name,
                    'Code': me.editForm.Code,
                    'Cube': me.editForm.Cube,
                    'Weight': me.editForm.Weight,
                    'Status': me.editForm.Status
                })
            .then((response) => {
                    if(response.data.IsSuccess)
                    {
                        this.$message("保存成功.")

                        this.LoadData();
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        console.log(strMsg);
                    }
            })
            .catch(function (error) {
                console.log(error);
            }); 
        },

          handleDelete(index, row) {
            this.$confirm('此操作将永久删除该客户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                var me = this;
                    var user = sessionStorage.getItem('user');
                    if (user) {
                        user = JSON.parse(user);
                    }

                    var Method = 'Production/delete/'+user.TokenId+"/"+user.LoginName+"/"+ row.Id;
                    this.$axios.post(Method)
                    .then((response) => {
                        if (response.status === 200) {
                            if(response.data.IsSuccess)
                            {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            
                                var newProductions = [];
                                    
                                me.Productions.forEach(element => {
                                    if(element.Id!=row.Id)
                                        newProductions.push(element);
                                    });

                                me.Productions = newProductions;
                                me.recordtotal -= 1;
                            }
                            else
                            {
                                var strMsg = '';
                                response.data.Messages.forEach(element => {
                                    strMsg += element.Message +'\r\n';
                                });
                                
                                this.alert(strMsg);
                            }
                        
                        }
                    })
                    .catch(function (error) {
                        this.alert(error);
                    }); 
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
          },
          
    }

}


// WEBPACK FOOTER //
// ./src/components/MaintainProduction/MaintainProduction.js